import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setLoading } from "lib/Reducer/loadingSlice";
import { useDispatch, useSelector } from "react-redux";

const Loader = () => {
  const isLoading = useSelector((state) => state?.loading?.status);
  const dispatch = useDispatch();
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
      onClick={() => dispatch(setLoading(false))}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
